import { useEffect, useState, useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Spinner, Alert, Container, Row, Col } from 'react-bootstrap';
import { getProducts } from '../http/productAPI'; // заменим позже если нужно
import { Context } from '../index';
import ProductList from "../components/ProductList";



const SearchPage = () => {
    const [searchParams] = useSearchParams();
    const query = searchParams.get('query') || '';

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [results, setResults] = useState([]);

    const { product } = useContext(Context); // если нужно что-то класть в store

    useEffect(() => {
        if (!query.trim()) return;
       
        setLoading(true);
        setError('');
        getProducts( 2, 0, 20, {searchQuery: query, parameters: [] })
            .then((data) => {
                //setResults(data.products || []);
                product.setProducts(data.products);
               // console.log ("results", results)
              //  console.log ("data.products", data.products)
                // product.setProducts(data.products); // если нужно положить в store
            })
            .catch((err) => {
                setError('Ошибка при поиске. Попробуйте позже.');
                console.error(err);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [query]);

    return (
        <div className="py-4">
       {/* <Container className="py-4">
            <h2 className="mb-4">Результаты поиска: «{query}»</h2>

            {loading && (
                <div className="text-center">
                    <Spinner animation="border" />
                </div>
            )}

            {error && <Alert variant="danger">{error}</Alert>}

            {!loading && !error && results.length === 0 && (
                <Alert variant="info">Ничего не найдено. </Alert>
            )}

            <Row>
                {results.map((item) => (
                    <Col key={item.id} xs={6} md={4} lg={3} className="mb-4">
                        <ProductCardSearch product={item} />
                     {/* <ProductItem productItem={item} /> */} {/*
                    </Col>
                ))}
            </Row>
           
        </Container> */}
        <h2 className="mb-4 mb-4 text-center">Результаты поиска: «{query}»</h2>

            {loading && (
                <div className="text-center">
                    <Spinner animation="border" />
                </div>
            )}

        <Container>            
                <ProductList/>                  
        </Container>
        </div>
    );
};

export default SearchPage;
